export default (initialState = {}) => {
  return () => {
    return {
      business_channel: [],
      email: "",
      name: "",
      phone: "",
      role: "",
      shop_name: "",
      trade_name: "",
      is_internal_user: false,
      distribution_type: "wholesaler",
      ...initialState,
    };
  };
};
